import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import LeftMenu from "../Components/LeftMenu";

const Resources = () => {
  return (
    <Container>
      <Row>
        <Col lg="4">
          <LeftMenu />
        </Col>
        <Col lg="8">
          <h1 className="toph1 font-mont">ABOUT</h1>
          <p>Look in the menu on the left for different resources for creators.</p>
        </Col>
      </Row>
    </Container>
  );
};

export default Resources;
